// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"772bfa10","453":"9bf0fb47","592":"e039eab4"}[chunkId] + ".chunk.js";
};